module.exports = __webpack_public_path__ + "img/infrastructure-9.e8b4fdd0.png";